export default __webpack_public_path__ + "static/media/chevron2.92b06c2c.svg";